import { isValidElement, type ReactNode } from 'react'

export function extractTextFromNode(node: ReactNode): string {
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (isValidElement<{ children?: ReactNode }>(node))
    return extractTextFromNode(node.props.children)
  if (Array.isArray(node)) return node.map(extractTextFromNode).join('')
  return ''
}
